<template>
  <div class="blog-header">
    <div class="container">
      <div class="row">
        <div class="col col-5">
          <h1 v-html="title" />
          <p class="body-1" v-html="description" />
        </div>
        <div class="slot col col-5 offset-2">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
  },
};
</script>
<style scoped lang="scss">
.blog-header {
  position: relative;
  background: var(--main-dark);
  color: var(--main-light);
  display: flex;
  align-items: center;
  height: 478px;

  .row {
    align-items: center;
  }

  h1 {
    margin: 0;
    margin-top: var(--spacing-lg);
  }

  .body-1 {
    font-weight: normal;
    color: var(--main-light-shade-4);
    margin: var(--spacing-16) 0 0;
  }

  h5 {
    margin: 0;
  }

  .input-group {
    display: flex;
    height: 56px;
    padding-right: var(--spacing-40);
    margin-top: var(--spacing-48);
    margin-bottom: var(--spacing-8);

    input {
      max-width: 270px;
      border-radius: 5px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      background: transparent;
      border: 1px solid rgba(255, 255, 255, 0.24);
      box-sizing: border-box;
      color: rgba(255, 255, 255, 0.48);

      &::placeholder {
        font-weight: normal;
        font-size: 18px;
        line-height: 120%;
        color: rgba(255, 255, 255, 0.48);
        opacity: 1;
      }

      &:-ms-input-placeholder {
        color: rgba(255, 255, 255, 0.48);
      }

      &::-ms-input-placeholder {
        color: rgba(255, 255, 255, 0.48);
      }
    }

    button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  small {
    display: block;
    color: var(--main-red);
    margin-top: 4px;
  }

  &:before {
    content: '';
    background: linear-gradient(253.23deg, rgba(0, 164, 178, 0.2) 0%, rgba(0, 164, 178, 0.05) 44.75%, rgba(0, 164, 178, 0) 94.77%);
    transform: matrix(-1, 0, 0, 1, 0, 0);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
  }

  .custom-checkbox + label {
    color: var(--main-light);
  }

  .custom-checkbox + label:after {
    background-color: var(--main-light);
  }

  .custom-checkbox:checked + label:after {
    background-color: var(--accent-shade-1);
  }
}

@include bp($bp-mobile) {
  .blog-header {
    height: auto;
    padding-top: 68px;
    padding-bottom: var(--spacing-80);

    h1 {
      width: 100%;
      text-align: center;
      margin-top: var(--spacing-80);
      margin-bottom: var(--spacing-60);
    }

    .body-1 {
      text-align: center;
    }

    .slot {
      margin-top: 44px;
      text-align: center;
    }

    .input-group {
      padding-right: 0;
      max-width: 500px;
      margin: 0 auto;

      input {
        max-width: 100%;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
      }

      ~ label {
        margin-top: var(--spacing-16);
        text-align: left;
      }
    }
  }
}

@include bp($bp-phone) {
  .blog-header {
    .input-group {
      flex-direction: column;
      height: auto;

      button {
        margin-top: var(--spacing-16);
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
      }
    }
  }
}
</style>
